import { ERROR_CODES } from '@/consts';

export default class ClosureIsNotLatest extends Error {
  static code = ERROR_CODES.CASH_LOG_CLOSURE_IS_NOT_LATEST;

  constructor(message) {
    super(message || 'Cash closure is not latest.');
    this.code = ERROR_CODES.CASH_LOG_CLOSURE_IS_NOT_LATEST;
  }
}
